import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useActionToast } from '@/Hooks/useActionToast';
import { createTour } from '../Services/Tours.service';
import { toursQueryKeys } from '../Constants/queryKeys';

export const useCreateTour = () => {
  const queryClient = useQueryClient();
  const toast = useActionToast();

  return useMutation({
    mutationFn: createTour,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: toursQueryKeys.lists() });
      toast.success('Tour criado');
    },
    onError: (error: Error) => {
      toast.failure('Não foi possível criar o tour', error);
    },
  });
};
